import { reduxForm, Field, SubmissionError } from 'redux-form'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

function _handleSubmissionError(args) {
	console.error('There was a submission Error', args)
	const [payload, initialPayload, resp] = args;
	const errors = get(resp, 'xhr.response.errors');
	const _error = get(resp, 'xhr.response.non_field_errors.0');


	if (_error || !isEmpty(errors)) throw new SubmissionError({...errors, _error})
}

const handleSubmissionError = (api: (data) => Promise<any>) => data =>
	api(data)
	.catch(_handleSubmissionError)

import * as React from 'react'
const Activatable = ({onActivate, Element, children=[], ...props}) =>
	React.createElement(Element, {
		tabIndex: 0,
		onKeyPress: e => ((e.key === 'Enter') && onActivate()),
		onClick: onActivate,
		...props
	}, children)

export { handleSubmissionError, Activatable, _handleSubmissionError }



// WEBPACK FOOTER //
// ./src/app/containers/utils.ts